import { render, staticRenderFns } from "./dialecticForm.vue?vue&type=template&id=b0c5bc4a&scoped=true&"
import script from "./dialecticForm.vue?vue&type=script&lang=ts&"
export * from "./dialecticForm.vue?vue&type=script&lang=ts&"
import style0 from "./dialecticForm.vue?vue&type=style&index=0&id=b0c5bc4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c5bc4a",
  null
  
)

export default component.exports